import * as React from 'react';

const SvgIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    fill="none"
    viewBox="0 0 24 25"
  >
    <circle
      cx="12"
      cy="12.5"
      r="12"
      fill="#fff"
      className="error-circle-svg"
    ></circle>
    <path
      fill="#E33B32"
      fillRule="evenodd"
      d="M14.854 10.385a.5.5 0 0 0-.708-.707L12 11.824 9.854 9.678a.5.5 0 1 0-.708.707l2.147 2.146-2.147 2.147a.5.5 0 1 0 .708.707L12 13.238l2.146 2.147a.5.5 0 0 0 .708-.707l-2.147-2.147z"
      clipRule="evenodd"
      className="path-svg"
    ></path>
  </svg>
);

export default SvgIcon;
